import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductionJobSharedDetail } from "../models/ui/production-job-shared-detail.model";
import { ProductionJobDownloadSharedSdk } from "../sdks/production-job-download-shared.sdk";

@Injectable({
	providedIn: 'root'
})
export class ProductionJobDownloadSharedManager {

	constructor(private productionJobDownloadSharedSdk: ProductionJobDownloadSharedSdk) {
	}

	public getProductionJobSharedDetail(sharedId: string): Observable<ProductionJobSharedDetail> {
		return this.productionJobDownloadSharedSdk.getProductionJobBySharedId(sharedId);
	}
}
